import type { LlmProviderId } from "./llmConfig";

/**
 * Giảm độ dài lịch sử gửi lên LLM (Cerebras mặc định Qwen — ngữ cảnh lớn).
 */
export function trimHistoryForLlm(
  history: { role: "user" | "assistant"; content: string }[],
  provider: LlmProviderId,
  _model: string
): { role: "user" | "assistant"; content: string }[] {
  if (provider !== "cerebras") {
    return history.length > 120 ? history.slice(-120) : history;
  }

  const maxMessages = 40;
  const maxChars = 48000;

  let h =
    history.length > maxMessages ? history.slice(-maxMessages) : [...history];

  let total = h.reduce((s, m) => s + (m.content?.length ?? 0), 0);
  while (total > maxChars && h.length > 1) {
    h.shift();
    total = h.reduce((s, m) => s + (m.content?.length ?? 0), 0);
  }
  return h;
}
